<template>
  <div class="content-grid content-grid--subpage">
    <Breadcrumbs :title="t(`routes.admin.children.organizations.editContact.name`)" />
    <BackLinkTitle :title="t(`routes.admin.children.organizations.editContact.name`)" />
    <Card>
      <ContactForm :id="organizationId" @formSubmit="handleSubmit" :contact="contact"/>
    </Card>
  </div>
</template>

<script lang="ts" setup>
import {ref} from "vue";
import {useI18n} from "vue3-i18n";
import {useContactService} from "@/inversify.config";
import {Contact} from "@/types/entities/contact";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import Card from "@/components/layout/Card.vue";
import ContactForm from "@/components/forms/ContactForm.vue";
import {notifyError, notifySuccess} from "@/notify";
import {useRouter} from "vue-router";
import {useMemberStore} from "@/stores/memberStore";

// eslint-disable-next-line no-undef
const props = defineProps<{
    organizationId?: string
    contactId: string
}>();

const {t} = useI18n()
const router = useRouter()
const memberStore = useMemberStore()
const contactService = useContactService()

const organizationId = props.organizationId ? props.organizationId : memberStore.getMember.organizationId

const contact = ref<Contact>(await contactService.getContact(organizationId, props.contactId));

async function handleSubmit(contact: Contact) {
    let succeededOrNotResponse = await contactService.updateContact(contact, organizationId)
    if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
        notifySuccess(t('validation.contact.edit.success'))
        setTimeout(() => {
            router.back();
        }, 1500);
    } else {
        let errorMessages = succeededOrNotResponse.getErrorMessages('validation.contact.edit');
        if (errorMessages.length == 0)
          notifyError(t('validation.contact.edit.errorOccurred'))
        else
          notifyError(errorMessages[0])
    }
}
</script>
